import axios from '../config/axios';

let company = JSON.parse(localStorage.getItem("company-s10"));
let user = JSON.parse(localStorage.getItem("user-s10"));

const signalRequest = async ( requestId, objectName ) => {
	const body = {
		HasOutputParam: false,
		ObjectName: objectName,
		RequestId: requestId,
		SignalRConnectionID: await localStorage.getItem("connectionId"),
		SecurityUserId: user.IdUser ? user.IdUser : user.UserId, // SecurityUserId obtenido al logear
	};
	const headers = {
		Token: company.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
	};
	
	await axios.post( 
		"",
		body,
		{
			headers: headers,
		}
	);
}

export const coinsFn = () =>{
	return async () =>{
		await signalRequest(
			"COINS",
			`dbo.S10_06_PCG_ListaMoneda`,
		);
	}
}